<div class="redirect">
    <div style="display: flex; flex-direction: column;">
        <img src="/assets/svg/openfinance.svg" class="openbanking">
        <div class="title" [class.success]="transactionWasSuccessful" [class.error]="!transactionWasSuccessful">{{ title }}</div>
        <span class="origin" [class.error]="!transactionWasSuccessful">{{ consent.organizationName }}</span>
        <img [src]="" class="client">
        <img src="/assets/svg/openbanking_redirect.svg" class="openbanking_redirect">
    </div>
</div>